<div class="info" *ngIf="hasContent">
  <div class="codeNumbers">
    <div class="codeNumbers__content">
      <div class="codeNumbers__item" *ngIf="otp">
        <div class="subtitle mb-5"><h2>Pin de seguridad</h2></div>
        <div class="codeNumbers__input"><span>{{ otp }}</span></div>
      </div>
      <div class="codeNumbers__item" *ngIf="contractNumber">
        <div class="subtitle mb-5"><h2>N° de Contrato</h2></div>
        <div class="codeNumbers__input"><span>{{ contractNumber }}</span></div>
      </div>
      <div class="codeNumbers__item" *ngIf="personNumber">
        <div class="subtitle mb-5"><h2>N° de Cliente</h2></div>
        <div class="codeNumbers__input"><span>{{ personNumber }}</span></div>
      </div>
    </div>
  </div>
</div>
